import React, { useRef, useContext } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import moment from "moment/moment";
import message from "../../assets/message.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { MdOutlineCancel } from "react-icons/md";
import LogicContext from "../../Context/LogicContext";
import { useForm } from "react-hook-form";
import VoucherCreateTable from "./VoucherCreateTable";
import { GetVoucherListAtom, SetVoucherListAtom } from "../../store/voucherAtom";
import CooperateSelect from "./CooperateSelect";
import { voucherService } from "../../services/voucherService";
import { accountService } from "../../services/accountService";




const AddCorporateVoucherPage = () => {

    const navigate = useNavigate();
    const myPromiseModal = createModal(GeneralModal);
    const logicContext = useContext(LogicContext);
    const { register, setValue, getValues, handleSubmit, control, reset, formState: { errors } } = useForm();
    const getVoucherData = GetVoucherListAtom();
    const setVoucherAtomData = SetVoucherListAtom();


    useEffect(() => {



        return () => {
            // Cleanup
            setVoucherAtomData(prev => {
                return { ...prev, newVoucherList: [] };
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async () => {
        const newData = getValues();

        if (!newData?.customer_id) {
            return logicContext.showToast("Please select a corporate User!", "error");
        }

        await myPromiseModal({
            title: "Do you want to Create Voucher?", body: `The following action will create ${newData?.quantity} quantity of ₦${newData?.amount} Voucher(s)`,
            showInput: false, placeHolder: '',
        }).then((res) => {
            if (res.decision === true) {

                voucherService.createVoucher(newData).then((res) => {
                    if (res.data?.result_status[0]?.message_id === 1) {
                        setVoucherAtomData(prev => {
                            return { ...prev, newVoucherList: res.data?.voucher_info };
                        });
                        logicContext.showToast(res.data?.result_status[0]?.message_text, "success");
                    } else {
                        logicContext.showToast("error Creating Voucher", "error");

                    }


                });
            }
        }).catch((err) => {
            // logicContext.showToast("error submitting record", "error");
        });
    };

    function formError(error) {
        logicContext.showToast("Form error", "error");
    }



    const shareActionButtonAll = async (selectedIdList) => {
        if (selectedIdList.length < 1) {
            return logicContext.showToast(`No selection was made. Please select one or more vouchers`, "error");
        }
        await myPromiseModal({
            title: "Confirm Share action?", body: `A total of  ${selectedIdList?.length} Voucher(s)  will be allocated`,
            showInput: false, placeHolder: '',
        }).then((res) => {
            if (res.decision === true) {

                let xml_voucher = "";
                let temp = "";
                let cop_ref = '';

                let i = 0;
                let j = 0;
                let found = false;
                while (i < selectedIdList.length && j < getVoucherData.newVoucherList.length) {
                    let voucherId = selectedIdList[i];
                    let voucher = getVoucherData.newVoucherList[j];
                    if (voucher?.Ref_No === voucherId) {
                        cop_ref = voucher?.Corporate_Ref_No;
                        found = true;
                        temp += `<a>
                        <voucher_no>${voucher.Voucher_Number} </voucher_no>
                        <name>${voucher?.Reciepient_Name ? voucher?.Reciepient_Name : ''} </name>
                        <mobile>${voucher?.Reciepient_Mobile_Number ? voucher?.Reciepient_Mobile_Number : ''} </mobile>
                        <email>${voucher?.Reciepient_Email_Address ? voucher?.Reciepient_Email_Address : ''} </email>
                         </a>`;
                        i += 1;
                    }
                    j += 1;
                }

                if (!found) {
                    return logicContext.showToast(`Selected Voucher(s) does not exist in table List`, "");
                }

                xml_voucher = `<root> ${temp} </root>`;
                voucherService.shareVouchers({ ref_no: cop_ref, xml_voucher: xml_voucher.replace(/^\s+|\s+$/gm, '') }).then((res) => {

                    voucherService.voucherDetails(cop_ref).then(res => {
                        if (res.data?.length) {
                            setVoucherAtomData(prev => {
                                return { ...prev, newVoucherList: res.data };
                            });
                        }
                    });
                });
            }
        }).catch((err) => {
            // logicContext.showToast("error submitting record", "error");
        });

    }





    const onCooperateSelect = (user) => {
        setValue("customer_id", user?.Customer_Id);
    }


    function onErrors(error) {
        // logicContext.showToast("Form error", "error");
    }


    return (
        <>
<section className="mt-4 w-full max-w-6xl">
  <div className="text-gray-700">
    <form onSubmit={handleSubmit(onSubmit, onErrors)} className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-bold text-gray-800">VOUCHER CREATE</span>
        <MdOutlineCancel size={20} className="cursor-pointer text-gray-600 hover:text-gray-800" />
      </div>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="md:w-1/2 space-y-4">
          <div>
            <label className=" mb-1">
              <span className="text-sm font-bold text-gray-800">
                Corporate User <span className="text-red-500 font-bold">*</span>:
              </span>
              <CooperateSelect onCooperateSelect={onCooperateSelect} list={getVoucherData.corporate_info} />
            </label>
          </div>
          <div className="flex flex-col md:flex-row gap-4">
            <label className=" mb-3 flex-1">
              <span className="text-sm font-bold text-gray-800">
                Total Voucher Quantity <span className="text-red-500 font-bold">*</span>:
              </span>
              <input
                className="mt-1 w-full px-3 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white text-sm"
                placeholder="Enter quantity"
                name="quantity"
                type="number"
                {...register("quantity", {
                  required: "Quantity is required",
                  pattern: {
                    value: /^[1-9]\d*/,
                    message: "Please enter a valid quantity!",
                  },
                })}
              />
              {errors.quantity?.message && (
                <small className="text-red-500 text-xs mt-1">{errors.quantity.message}</small>
              )}
            </label>
            <label className=" mb-3 flex-1">
              <span className="text-sm font-bold text-gray-800">
                Amount Per Voucher (₦) <span className="text-red-500 font-bold">*</span>:
              </span>
              <input
                className="mt-1 w-full px-3 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white text-sm"
                placeholder="Enter amount per voucher"
                type="number"
                name="amount"
                {...register("amount", {
                  required: "Amount is required",
                  pattern: {
                    value: /^[1-9]\d*/,
                    message: "Please enter a valid amount!",
                  },
                })}
              />
              {errors.amount?.message && (
                <small className="text-red-500 text-xs mt-1">{errors.amount.message}</small>
              )}
            </label>
          </div>
        </div>
        <div className="md:w-1/2">
          <label className=" mb-3">
            <span className="text-sm font-bold text-gray-800">Description:</span>
            <input
              className="mt-1 w-full px-3 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white text-sm h-32"
              placeholder="Enter notification message"
              name="message"
              {...register("remark")}
            />
          </label>
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <button
          type="submit"
          className="px-4 py-2 bg-blue-700 text-white text-sm font-medium rounded-lg hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-300 transition-colors duration-200"
        >
          Purchase
        </button>
      </div>
    </form>
    {getVoucherData?.newVoucherList?.length && (
      <div className="border-2 border-gray-200 rounded-lg mt-4 bg-gray-50 p-4">
        <span className="text-sm font-bold text-gray-800  text-center mb-2">
          NEW VOUCHER LIST
        </span>
        <VoucherCreateTable
          shareActionButtonAll={shareActionButtonAll}
          newVoucherList={getVoucherData.newVoucherList}
        />
      </div>
    )}
  </div>
</section>
        </>
    );
};

export default AddCorporateVoucherPage;
